
import { defineComponent, PropType, computed, ref, onMounted, onUnmounted } from 'vue';
import useStatus from './useStatus';

export default defineComponent({
  name: 'CardItem',
  props: {
    server: {
      type: Object as PropType<any>, // 使用 any 避免 TS 报错
      default: () => ({})
    }
  },
  setup(props) {
    const utils = useStatus(props);

    const now = ref(Date.now());
    let timeTimer: number | undefined;

    onMounted(() => {
      // 每 5 秒更新一次当前时间，强制触发 getStatus 重新计算
      timeTimer = window.setInterval(() => {
        now.value = Date.now();
      }, 5000);
    });

    onUnmounted(() => {
      if (timeTimer) window.clearInterval(timeTimer);
    });

    // 2. 重写 getStatus 逻辑，加入 30 秒超时判定
    const getStatus = computed(() => {
      // 基础网络标志
      const isNetworkOnline = props.server.online4 || props.server.online6;
      if (!isNetworkOnline) return false;

      // 数据新鲜度判定 (30秒 = 30000毫秒)
      const lastUpdate = props.server.updated_at;
      if (!lastUpdate) return false; // 没有时间戳，保守视为离线

      // 依赖 now.value，确保时间到了会自动变离线
      const isFresh = (now.value - lastUpdate) < 30000;

      return isFresh;
    });

    return {
      ...utils,
      getStatus // 显式放在最后，确保覆盖 utils 中原有的 getStatus
    };
  }
});
